import React from 'react';
import { DropdownBox, Searchbox, DropdownMenuItemType } from '@softura/fluentuipackage'
import './dropdownbox.scss';

interface IProps {
    placeholder?: any,
    options?: any,
    SelectedView?: any,
    selectedKey?: string,
    defaultSelectedKey?: any,
    className?: string | number,
    onChange?: any,
    onBlur?: any,
    calloutClass? : any,
}
const DropdownBoxContainer = (props: IProps) => {
    const [searchText, setSearchText] = React.useState<string>('');

    function renderOption(option: any): React.JSX.Element {
        return (option.itemType === DropdownMenuItemType.Header && option.key === "FilterHeader") ?
            <Searchbox onChange={(ev: any, newValue: any) => setSearchText(newValue)} placeholder="Search options" /> : <>{option.text}</>;
    }
    return <DropdownBox
        placeholder={props.placeholder}
        onChange={props.onChange}
        selectedKey={props.selectedKey}
        defaultSelectedKey={props.defaultSelectedKey}
        className={props.className}
        onBlur={props.onBlur}
        {...props}
        options={[
            { key: 'FilterHeader', text: '-', itemType: DropdownMenuItemType.Header },
            { key: 'divider_filterHeader', text: '-', itemType: DropdownMenuItemType.Divider },
            ...props.options.map((option: any) => !option.disabled && option.text.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ?
                option : { ...option, hidden: true }
            ),
        ]}
        calloutProps={{ shouldRestoreFocus: false, setInitialFocus: false, className: props.calloutClass }} //not working
        onRenderOption={renderOption}
        onDismiss={() => setSearchText('')}

    />
}

export default DropdownBoxContainer